<template>
  <div class="simple-luggage-upload">
    <h6 class="person-title">{{ personName }}</h6>

    <!-- Small Luggage -->
    <div v-if="person.luggage_small > 0" class="luggage-section">
      <h6 class="luggage-title">Lille Bagage ({{ person.luggage_small }} genstande)</h6>
      <div class="items-grid">
        <LuggageItem
          v-for="itemIndex in person.luggage_small"
          :key="`small-${itemIndex}`"
          :person-index="personIndex"
          :luggage-type="'small'"
          :item-index="itemIndex - 1"
          :photos="photos"
          :order-token="orderToken"
          @photoUploaded="photoUploaded"
          @photoDeleted="photoDeleted"
          @show-message="showMessage"
          @view-photo="viewPhoto"
        />
      </div>
    </div>

    <!-- Large Luggage -->
    <div v-if="person.luggage_large > 0" class="luggage-section">
      <h6 class="luggage-title">Stor Bagage ({{ person.luggage_large }} genstande)</h6>
      <div class="items-grid">
        <LuggageItem
          v-for="itemIndex in person.luggage_large"
          :key="`large-${itemIndex}`"
          :person-index="personIndex"
          :luggage-type="'large'"
          :item-index="itemIndex - 1"
          :photos="photos"
          :order-token="orderToken"
          @photoUploaded="photoUploaded"
          @photoDeleted="photoDeleted"
          @show-message="showMessage"
          @view-photo="viewPhoto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LuggageItem from './LuggageItem.vue'

export default {
  name: 'SimpleLuggageUpload',
  components: {
    LuggageItem
  },
  props: {
    person: {
      type: Object,
      required: true
    },
    personIndex: {
      type: Number,
      required: true
    },
    orderToken: {
      type: String,
      required: true
    },
    photos: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    personName() {
      return `${this.person.first_name} ${this.person.last_name}`
    }
  },
  methods: {
    photoUploaded(payload) {
      this.$emit('photoUploaded', payload)
      this.$emit('photo-uploaded', payload)
      
      // Fallback: direct parent call
      if (this.$parent && this.$parent.onPhotoUploaded) {
        this.$parent.onPhotoUploaded(payload)
      }
    },

    photoDeleted(payload) {
      this.$emit('photoDeleted', payload)
      this.$emit('photo-deleted', payload)
      
      // Fallback: direct parent call
      if (this.$parent && this.$parent.onPhotoDeleted) {
        this.$parent.onPhotoDeleted(payload)
      }
    },

    showMessage(message) {
      this.$emit('show-message', message)
    },

    viewPhoto(photoData) {
      this.$emit('view-photo', photoData)
    }
  }
}
</script>

<style lang="scss" scoped>
.simple-luggage-upload {
  border: 1px solid #E2E2E2;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  background: white;
}

.person-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.luggage-section {
  margin-bottom: 20px;
}

.luggage-title {
  font-size: 14px;
  font-weight: 600;
  color: #00A9E0;
  margin-bottom: 10px;
}

.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}

@media (max-width: 768px) {
  .items-grid {
    grid-template-columns: 1fr;
  }
}
</style> 